import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo, SyntheticEvent } from 'react'
import { IField, ILabel } from 'types/Form'
import s from './Input.module.css'
import Warning from "@components/warning";
import Label from '../label';
import {toDecimal, toInteger, toFixed, toMoney} from 'utils/numeric'

interface IInput extends IField {
    required?: boolean,
    name: string,
    id: string,
    type: string,
    className?: string,
    onChange?: (value: string) => void,
    onBlur?: (value: string) => void,
    label?: Omit<ILabel, "id">
    placeholder?: string,
    maxLength?: number;
    uppercaseValue?: boolean,
    disabled?: boolean,
}

const Input = ({ className, id, name, ready, type, value,
    placeholder = "",
    warning, required, onChange, onBlur, label,disabled,maxLength, uppercaseValue }: IInput) => {
    return <div className={cn(s.root, { [s.ready]: ready }, { [s.error]: warning }, className)}>
        {label ? <Label
            {...label}
            id={id}
        /> : null}
        <input
            value={value as string}
            step="0.01"
            lang="en-US"
            name={name}
            id={id}
            type={type.includes("number") ? "text" : type}
            required={required}
            className={cn(s.input)}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={maxLength}
            onBlur={(e) => {
                let value = e.target.value;
                if (type.includes("number")) {
                    value = toDecimal(e.target.value);
                    if (!type.includes("integer")) {
                        value = toFixed(value);
                    }
                }
                if (type.includes("percentage")) {
                    value = value + "%";
                }
                if (type.includes("money")) {
                    value = toMoney(value);
                }
                if (type.includes("text") && uppercaseValue){
                    if(value && value != ""){
                        value = value.toUpperCase();
                    }
                }
                e.target.value = value;
                if(onBlur){
                    onBlur(value);        
                } else if(onChange){
                    onChange(value);
                }
            }}
            onChange={(e) => {
                let value = e.target.value;
                if (type.includes("number")) {
                    if(type.includes("integer")){
                        value = toInteger(e.target.value);
                    }else{
                        value = toDecimal(e.target.value);
                    }
                }
                if (type.includes("text") && uppercaseValue){
                    if(value && value != ""){
                        value = value.toUpperCase();
                    }
                }
                e.target.value = value;

                if(onChange){
                    onChange(value);
                } else if(onBlur){
                    onBlur(value);
                }
            }}
        />
        <Warning warning={warning} />
    </div>
}
export default Input